import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiSignalRService } from '@fi-shared/fi-signal-r/fi-signal-r.service';
import { FiSignalRHelperService } from '@fi-shared/fi-signal-r/fi-signal-r-helper.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [FiSignalRService, FiSignalRHelperService],
})
export class FiSignalRModule {}
